import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Loader2, Lock, Guitar } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { useAuth } from '@/lib/auth';

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  if (user && !user.must_change_password) return <Navigate to="/admin/dashboard" replace />;
  if (user && user.must_change_password) return <Navigate to="/admin/trocar-senha" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success('Bem-vindo, ' + (u.name || u.email));
      if (u.must_change_password) nav('/admin/trocar-senha');
      else nav('/admin/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4 relative overflow-hidden g66-grain">
      <div className="w-full max-w-sm">
        <div className="flex items-center justify-center gap-2 mb-6">
          <div className="w-11 h-11 rounded-lg bg-[var(--g66-amber)] flex items-center justify-center text-black">
            <Guitar className="w-6 h-6" strokeWidth={2.5} />
          </div>
          <div className="leading-tight">
            <div className="font-display text-2xl text-white">GARAGE 66</div>
            <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Painel Administrativo</div>
          </div>
        </div>
        <Card className="border border-border bg-card">
          <CardContent className="p-6">
            <div className="flex items-center gap-2 text-white">
              <Lock className="w-4 h-4 text-[var(--g66-amber)]" />
              <div className="font-semibold">Acesso restrito</div>
            </div>
            <p className="text-xs text-muted-foreground mt-1">Entre com suas credenciais de administrador.</p>
            <form onSubmit={handleSubmit} className="mt-5 space-y-3">
              <div>
                <Label htmlFor="email">E-mail</Label>
                <Input id="email" data-testid="admin-login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1 bg-background" />
              </div>
              <div>
                <Label htmlFor="password">Senha</Label>
                <Input id="password" data-testid="admin-login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1 bg-background" />
              </div>
              <Button data-testid="admin-login-submit-button" type="submit" disabled={loading} className="w-full bg-[var(--g66-amber)] text-black hover:bg-[var(--g66-amber-2)]">
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Entrar'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
